<template>
  <div class="product-container" 
    :class="{over: over}"
    :style="productStyle"
    ref="dropzone"
    @dragenter.stop="onDragEnter"
    @dragleave.stop="onDragLeave"
    @dragover.stop="onDragOver"
    @drop.stop="onDrop"

    @dragstart="onDragStart" 
    @mousewheel="onScroll"
    @mousedown="onMouseDown"
    @mouseup="onMouseUp"
    >

      <div v-if="dblClickActive" class="overlay" @click="$emit('exit-dbl-click')"></div>

      <img v-show="dblClickActive && accessURL"
        class="overflow-image"
        :src="accessURL" 
        :style="photoStyle" />

      <div class="photo-container" :style="productTypeStyle" ref="photocontainer">
        <img v-if="product.photo.filename" 
          :src="accessURL" 
          :style="photoStyle"
          @load="setMinScale()"
          ref="photo"/>
        <div v-if="product.matte.size != 0 || product.frame.frameWidth > 0" class="inset-shadow"/>
      </div>

      <div id="textnode" v-show="over && !product.photo.filename">Drop photo here.</div>
      <img class="invisible-drag-ghost-dummy" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" style="visibility: hidden;" ref="ghostDummy">
  </div>
</template>

<script>
export default {
  name: 'Product',
  props: {
    product: {
      type: Object,
      required: true
    },
    dblClickActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      over: false,

      mousePosition: {x:0, y:0},
      dragStartPhotoPosition: { top: 0, left: 0 },

      dragging: false,
    }
  },
  mounted() {
    let url = require('@/assets/'+this.product.type+'.jpg')
    this.$refs.photocontainer.style.backgroundImage = `url(${url})`
  },
  methods: {
    onMouseDown(e) {
      this.mousePosition.x = e.pageX
      this.mousePosition.y = e.pageY
      this.dragStartPhotoPosition.top = this.product.photo.top
      this.dragStartPhotoPosition.left = this.product.photo.left
      window.addEventListener('mousemove', this.onMouseMove)
      window.addEventListener('mouseup', this.onMouseUp)
      this.dragging = true
    },
    onMouseUp() {
      this.dragging = false
      window.removeEventListener('mousemove', this.onMouseMove)
      window.removeEventListener('mouseup', this.onMouseUp)
    },
    onMouseMove(e) {
      e.preventDefault()
      if(this.dblClickActive && this.dragging) {
        let minX = ((this.$refs.photo.width - this.width)*-1)/this.width*100
        let minY = ((this.$refs.photo.height - this.height)*-1)/this.height*100
        let deltaX = (e.pageX - this.mousePosition.x)/this.width*100
        let deltaY = (e.pageY - this.mousePosition.y)/this.height*100
        this.product.photo.left = Math.round(Math.max(minX, Math.min(0, deltaX+this.dragStartPhotoPosition.left)))
        this.product.photo.top = Math.round(Math.max(minY, Math.min(0, deltaY+this.dragStartPhotoPosition.top)))
      }
    },
    onDragStart(e) {
      e.dataTransfer.setDragImage(this.$refs.ghostDummy, 0, 0);
    },
    onScroll(e){
      e.preventDefault()
      if(this.dblClickActive) {
        let scalePercentage = (e.detail<0 || e.wheelDelta>0) ? 3 : -3
        scalePercentage = Math.floor(this.product.photo.scale/100)*scalePercentage // scale faster when extremly large
        if(this.product.photo.scale + scalePercentage >= this.getMinWidthScale() && 
           this.product.photo.scale + scalePercentage >= this.getMinHeightScale()) {
          this.product.photo.scale += scalePercentage
          this.$nextTick(() => {
            let minX = ((this.$refs.photo.width - this.width)*-1)/this.width*100
            let minY = ((this.$refs.photo.height - this.height)*-1)/this.height*100
            this.product.photo.left = Math.round(Math.max(minX, Math.min(0, this.product.photo.left)))
            this.product.photo.top = Math.round(Math.max(minY, Math.min(0, this.product.photo.top)))
          })
        }
      }
    },
    onDragEnter(e) {
      e.preventDefault()
      if(this.dblClickActive)
        return
      this.over = true
    },
    onDragLeave(e) {
      e.preventDefault();
      if(this.dblClickActive)
        return
      this.over = false
    },
    onDragOver(e) {
      e.preventDefault();
      if(this.dblClickActive)
        return
      this.over = true
    },
    onDrop(e) {
      e.preventDefault();
      this.over = false
      if(this.dblClickActive)
        return

      if(!e.dataTransfer.getData("imgurl")) {
         // something other than one of our images was dropped
        return
      }
      
      const p = JSON.parse(e.dataTransfer.getData("imgurl"))
      console.dir(p)
      if(p.url && p.name) {
        this.product.photo = { 
          top: 0, 
          left: 0, 
          scale: 100,
          filename: p.name,
          // aspectRatio: 1
        }
      }
    },
    setMinScale() {
      if(!this.$refs.photo) {
        return
      }
      const photoAspectRatio = this.$refs.photo.width/this.$refs.photo.height

      const photoHeight = this.productHeight*this.product.photo.scale/100 // in pixel
      const photoWidth = photoHeight*photoAspectRatio
      const left = this.product.photo.left*-1
      const fullWidthToCover = left + this.productWidth

      if(photoWidth < fullWidthToCover) {
        this.product.photo.left = 0
        this.product.photo.scale = this.getMinWidthScale()
      }

      const fullHeightToCover = this.product.photo.top + this.productHeight

      if(photoHeight < fullHeightToCover) {
        this.product.photo.top = 0
        this.product.photo.scale = this.getMinHeightScale()
      }
    },
    getMinWidthScale() {
      if(!this.$refs.photo) {
        return
      }
      const photoAspectRatio = this.$refs.photo.width/this.$refs.photo.height
      const productAspectRatio = this.productWidth/this.productHeight
      return productAspectRatio/photoAspectRatio*100
    },
    getMinHeightScale() {
      return 100 // fix since we set photo height explicitly in css
    }
  },
  computed: {
    productStyle() {
      let style = {}
      style.width = this.width + 'px'
      style.height = this.height + 'px'
      return style
    },
    productTypeStyle() {
      if(this.product.type == 'wood') {
        return {
          borderRadius: Math.round(this.pixelPerUnit*0.75) + 'px'
        }
      }
      return {}
    },
    photoPosition() {
      return { top: this.product.photo.top*this.height/100 + 'px', left: this.product.photo.left *this.width/100+ 'px' }
    },
    photoSize() {
      return { height: this.productHeight*this.product.photo.scale/100 + 'px', width: 'auto' }
    },
    photoStyle() {
      return Object.assign({}, this.photoPosition, this.photoSize)
    },
    overflowImageStyle() {
      return Object.assign(this.photoSize, this.photoPosition)
    }, 
    productWidth() {
      return this.product.productSize[0]*this.pixelPerUnit
    },
    productHeight() {
      return this.product.productSize[1]*this.pixelPerUnit
    },
    width() {
      return this.productWidth
    },
    height() {
      return this.productHeight
    },
    productAspectRatio() {
      return this.productWidth/this.productHeight
    },
    pixelPerUnit() {
      return this.$store.getters.pixelPerUnit
    },
    accessURL() {
      if(this.product.photo.filename)
        return this.$store.getters.accessURL(this.product.photo.filename)
      return ''
    }
  },
  watch: {
    productAspectRatio() {
      this.setMinScale()
    }
  }
}
</script>

<style lang="scss" scoped>
.product-container {
  background-size: cover;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  box-sizing: border-box;
  position: relative;
  z-index: inherit;
}

.photo-container {
  overflow: hidden;
  max-width: 100%;
  width: 100%;
  max-height: 100%;
  height: 100%;
  position: relative;
  background-size: cover;

  img {
    pointer-events: none;
    user-select: none;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
  }

  .inset-shadow {
    box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}

.overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
}

.overflow-image {
  position: absolute;
  opacity: 0.4;
}

.over {
  transition: transform 0.2s;
  transform: scale(1.1);
  transform-origin: 50% 50%;
  z-index: 10;
}
#textnode {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-weight: bold;
  pointer-events: none;
}
</style>